import Vue from 'vue'
import VueRouter from 'vue-router'

import Home from '../pages/Home'
import Favorite from '../pages/Favorite'
import Flow from '../pages/Flow'
import Task from '../pages/Task'
import Message from '../pages/Message'

Vue.use(VueRouter)

export default new VueRouter({
    mode: 'history',
    base: __dirname,
    routes: [
        {
            path: '/home',
            name: 'home',
            component: Home
        },
        {
            path: '/favorites',
            name: 'favorites',
            component: Favorite
        },
        {
            path: '/flows',
            name: 'flows',
            component: Flow
        },
        {
            path: '/flows/task/:uuid',
            name: 'task',
            props: true,
            component: Task
        },
        {
            path: '/messages',
            name: 'messages',
            component: Message
        },
        {
            path: '/*',
            redirect: '/home'
        }
    ]
})


// WEBPACK FOOTER //
// ./src/router/index.js